import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { submitConfirmationCode } from '../../api/users/signUp';

function SubmitConfirmationCode() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(async () => {
    const confirmationToken = searchParams.get("confirmation_token")
    
    try {
      if (!confirmationToken) throw new Error('Confirmation token required'); 

      await submitConfirmationCode({
        confirmationToken: confirmationToken
      });

      navigate('/emailVerified');
    } catch (error) {
      // TODO: we need a way to alert the user if the confirmation token failed
      navigate('/signUp')
    } 
  }, []);

  return null;
}

export default SubmitConfirmationCode;
